import moment from "moment";

export const placeholderBirthdayDate = moment();

export const isPlaceholderBirthdayDate = (date: moment.Moment | Date) =>
  moment(date).isSame(placeholderBirthdayDate, "day");

export const differenceOfDaysFromToday = (date: string | null) => {
  if (!date) {
    return Infinity;
  }
  return moment().diff(moment(date), "days", true);
};

export const ownerLastActivityInformation = (date: string | null) => {
  if (date) {
    const lastActivity = Math.trunc(differenceOfDaysFromToday(date));

    if (lastActivity < 1) {
      return "Less than 24 hours ago";
    }
    if (lastActivity === 1) {
      return `${lastActivity} day ago`;
    }
    if (lastActivity > 1 && lastActivity < 30) {
      return `${lastActivity} days ago`;
    }
    if (lastActivity >= 30) {
      return "More than 30 days ago";
    }
  }
  return null;
};

export const calculateTermRemaining = (
  termExpiration: string,
  dealDate?: string,
) => {
  const now = !!dealDate ? moment(dealDate) : moment();
  return moment(termExpiration).diff(moment(now), "days") / 365.2425;
};
